import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="nested-fields"
export default class extends Controller {
  static targets = ["container", "template", "fieldGroup", "checkbox"];

  static values = {
    disableRemove: Boolean,
  };

  initialize() {
    // Keep track if unique checkboxes should be disabled for turbo navigation.
    this.checkBoxState = {};

    this.checkboxTargets.forEach((checkbox) => {
      this.checkBoxState[checkbox.dataset.key] = checkbox.dataset.disableTurbo === "true";
    });
  }

  addFields() {
    this.containerTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.replace(/__INDEX__/g, Date.now()));

    this.disableRemoveValue = this.fieldGroupTargets.length <= 1;
  }

  removeFieldGroup({ currentTarget }) {
    if (this.fieldGroupTargets.length <= 1) return;

    this.fieldGroupTargets.forEach((fieldGroup) => {
      if (fieldGroup.contains(currentTarget)) {
        fieldGroup.remove();
      }
    });

    this.disableRemoveValue = this.fieldGroupTargets.length <= 1;
  }
}
